import { render, staticRenderFns } from "./ElSubheadlineV2.vue?vue&type=template&id=2c782dea"
import script from "./ElSubheadlineV2.vue?vue&type=script&lang=js"
export * from "./ElSubheadlineV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports